<template>
  <div class="orderItem" @click="$emit('click')">
    <img class="img" :src="obj.cover || require('@/assets/images/img_default_02.png')" alt="">
    <div class="content">
      <div class="title">{{obj.title}}</div>
      <div class="code">订单号：{{ obj.orderNo }}</div>
      <div class="bottom">
        <div class="price">￥{{obj.price | toFixed}}</div>
        <div class="status" :class="{red:obj.status===0,blue:obj.status===1,gray:obj.status===2}">{{ ['待付款','已付款','已取消'][obj.status] }}</div>
      </div>
      <div class="btn_bottom" v-if="obj.status===0">
        <div class="btn btn_01" @click.stop="$emit('cancel')">取消支付</div>
        <div class="btn btn_02" @click.stop="$emit('clickBuy')">去支付</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderItem',
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="less" scoped>
.orderItem {
  width: 694px;
  padding: 30px 20px;
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  margin:0 auto 20px;
  .img {
    width: 216px;
    height: 144px;
    border-radius: 8px;
  }
  .content {
    flex:1;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    .title {
      font-size: 28px;
      color: #333444;
      font-weight: bold;
    }
    .code {
      margin-top: 16px;
      font-size: 24px;
      color: #999AAA;
    }
    .bottom {
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .price {
        font-size: 28px;
        line-height: 36px;
        color: #FF485D;
        font-weight: bold;
      }
      .status {
        font-size: 24px;
        font-weight: 400;
        line-height: 36px;
      }
      .red {
        color: #FF485D;
      }
      .blue {
        color: #5FA9FF;
      }
      .gray {
        color: #999AAA;
      }
    }
    .btn_bottom{
      display: flex;
      justify-content: right;
      align-items: center;
      padding-top: 30px;
      margin: 0 0 0 auto;
      .btn{
        padding: 4px 16px;
        background: #fff;
        border-radius: 15px;
        font-size: 24px;
        &.btn_01{
          border: 1px solid #999AAA;
          color: #999AAA;
        }
        &.btn_02{
          border: 1px solid #FF485D;
          color: #FF485D;
        }
        &:last-child{
          margin-left: 10px;
        }
      }

    }
  }
}
</style>